// extracted by mini-css-extract-plugin
export default {"Menu":"bgt_a bhi_h","Menu__offsetParent":"bgt_b bhi_bj","Menu__trigger--shadowed":"bgt_c"};